/* eslint-disable arrow-body-style */
import { SelectInputMulti } from '@abyss/web/ui/SelectInputMulti';
import React from 'react';
import { constants } from '@src/routes/provider/common/constants';
import {
  linkAnalysisFilterPanelApi,
  useLinkAnalysisFilterPanelStore,
} from '../../mothership/linkAnalysisFilterPanel.state';

export const NodesSelect = () => {
  const options = useLinkAnalysisFilterPanelStore((state) => state.nodeOptions);
  const value = useLinkAnalysisFilterPanelStore((state) => state.nodesSelected);
  const loading = useLinkAnalysisFilterPanelStore((state) => state.loading);
  const placeholder = loading ? constants.LOADING : 'Select Nodes';
  const renderValue = loading ? [''] : value;

  const { setNodesValue } = linkAnalysisFilterPanelApi;

  return (
    <div
      data-cy="link-analysis-select-nodes"
      data-value={value}
      data-options={JSON.stringify(options)}
      data-loading={loading}
    >
      <SelectInputMulti
        label="Nodes"
        placeholder={placeholder}
        value={renderValue}
        onChange={setNodesValue}
        options={options}
        selectAll
        hideChips
        isLoading={loading}
      />
    </div>
  );
};
